export const API_URL = process.env.REACT_APP_API_URL || 'https://api-alpha.refera.com.br/api/v1/'
export const NEXT_URL = process.env.REACT_APP_NEXT_PWA_APP_URL || 'http://localhost:3000'
export const GTM_ID = process.env.REACT_APP_GTM_ID
export const BE_API_KEY = process.env.REACT_APP_BE_API_KEY
// Versão obtida automaticamente do package.json via webpack
export const APP_VERSION = process.env.REACT_APP_VERSION || '1.0.0'
